import { IOption } from '@cian/ui-kit/types';
import { IApplicationState } from '../../types/redux';
import { getFilters } from '../filters';

export function getLocationsForSelect(state: IApplicationState): IOption[] {
  const {
    locations: { hash },
  } = state;
  const filters = getFilters(state);

  return filters.locationVariants.reduce((acc, curr) => {
    const regionName = hash[curr].name;

    if (!regionName) {
      return acc;
    }

    return [...acc, { label: regionName, value: curr }];
  }, []);
}
